import { isEmptyBlockContent } from 'shared-helpers/common';
import isCalendarEventFeedbackQuestionDataValid from './isCalendarEventFeedbackQuestionDataValid';

import type { CalendarEventFeedbackQuestion } from 'shared-types';

const calendarEventFeedbackQuestionTypes: CalendarEventFeedbackQuestion['type'][] =
  ['multiplechoice', 'openquestion', 'singlechoice', 'starrating'];

type QuestionType = CalendarEventFeedbackQuestion['type'];

type Params = {
  data: unknown;
  isRequired: boolean;
  question: unknown;
  type: unknown;
};

type CalendarEventFeedbackQuestionError =
  | 'invalid_data'
  | 'invalid_type'
  | 'question_missing';

/**
 * Checks a whole feedback question - its text, its type and its type specific
 * data - and returns which rule it broke, or undefined when it is valid. The
 * editor uses it to block saving an invalid question and the API uses it to
 * answer with the matching error, so both sides apply the same rules.
 *
 * The question text is rich text, so an empty editor still arrives as markup
 * like "<p></p>" and has to be stripped before it can be called blank.
 */
const validateCalendarEventFeedbackQuestion = ({
  data,
  isRequired,
  question,
  type
}: Params): CalendarEventFeedbackQuestionError | undefined => {
  if (typeof question !== 'string' || isEmptyBlockContent(question)) {
    return 'question_missing';
  }

  if (!calendarEventFeedbackQuestionTypes.includes(type as QuestionType)) {
    return 'invalid_type';
  }

  if (
    !isCalendarEventFeedbackQuestionDataValid({
      data,
      isRequired,
      type: type as QuestionType
    })
  ) {
    return 'invalid_data';
  }

  return undefined;
};

export default validateCalendarEventFeedbackQuestion;
